export default function ArrayToOptions(list, vkey, lkey) {
  return list.map(item => ({
    value: item[vkey],
    label: item[lkey]
  }));
}
